import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LoaderComponent } from './components/utils/loader/loader.component';
import { ThemeService } from './core/services/theme.service';
import { VersionUpdateService } from './core/services/version-update.service';
import { BRANDING } from './core/config/branding';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet,LoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal(BRANDING.name);
  private readonly themeService = inject(ThemeService);
  private readonly versionUpdateService = inject(VersionUpdateService);
  private readonly titleService = inject(Title);

  ngOnInit(): void {
    this.titleService.setTitle(BRANDING.name);
    this.versionUpdateService.start();
  }
}
